// Everything under /cave/*, rendered inside PublicLayout's dark
// `<main class="cave-main">` (build-plan R3). Signed out: the Hidden
// Treasure Cave sign-in page (Landing, restyled by wave-2 brief P5). Signed
// in: the existing members' area, now served at /cave/... instead of /...,
// wrapped in `.chv-app` so tokens.css applies.
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { canManage } from '@clan-heart/shared';
import { useMe } from '../hooks/useMe.js';
import { signinMessageFor } from '../lib/signinMessage.js';
import { Landing } from '../pages/Landing.js';
import { PendingApproval } from '../pages/PendingApproval.js';
import { Shell } from '../pages/Shell.js';
import { AccomplishmentsPage } from '../pages/AccomplishmentsPage.js';
import { LeaderboardPage } from '../pages/LeaderboardPage.js';
import { MyClaimsPage } from '../pages/MyClaimsPage.js';
import { ReviewPage } from '../pages/ReviewPage.js';
import { ManagePage } from '../pages/ManagePage.js';
import { CrewPage } from '../pages/CrewPage.js';
import { CrewMemberPage } from '../pages/CrewMemberPage.js';
import { ShipsPage } from '../pages/ShipsPage.js';
import { MyProfilePage } from '../pages/MyProfilePage.js';
import { NotFoundPage } from '../pages/NotFoundPage.js';

export function CaveArea() {
  const meQuery = useMe();
  const [searchParams] = useSearchParams();

  if (meQuery.isLoading) {
    return <p>Loading…</p>;
  }

  const me = meQuery.data ?? null;

  if (!me) {
    return <Landing signinMessage={signinMessageFor(searchParams.get('signin'))} />;
  }

  if (me.status === 'pending') {
    return <PendingApproval />;
  }

  // rejected and removed people are signed out server-side; should a stale
  // answer still say so, never show them the members' area
  if (me.status !== 'approved') {
    return <Landing signinMessage={signinMessageFor(me.status)} />;
  }

  const manages = canManage(me.role);

  return (
    <div className="chv-app">
      <Routes>
        <Route element={<Shell me={me} />}>
          <Route index element={<AccomplishmentsPage />} />
          <Route path="leaderboard" element={<LeaderboardPage me={me} />} />
          <Route path="claims" element={<MyClaimsPage />} />
          <Route path="profile" element={<MyProfilePage />} />
          <Route
            path="review"
            element={manages ? <ReviewPage me={me} /> : <Navigate to="/cave" replace />}
          />
          <Route path="manage" element={manages ? <ManagePage /> : <Navigate to="/cave" replace />} />
          <Route
            path="crew"
            element={manages ? <CrewPage me={me} /> : <Navigate to="/cave" replace />}
          />
          <Route
            path="crew/:slug"
            element={manages ? <CrewMemberPage /> : <Navigate to="/cave" replace />}
          />
          <Route path="roster" element={<Navigate to="/cave/crew" replace />} />
          <Route path="ships" element={manages ? <ShipsPage /> : <Navigate to="/cave" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </div>
  );
}
